export default "__VITE_ASSET__aJP5dPet__"